(() => {
  const moduleName = 'cartPage';
  const cartPageModule = App[moduleName] || {};

  App[moduleName] = (() => {
    const ANIMATION_DURATION = 500;
    const isCartPage = App.currentPage === 'cartPage';
    const orders = {};

    const fillUpOrderRowConfig = (item, isGroupedOrder = false) => {
      const orderRow = item.productItem;
      orderRow.isGroupedOrder = isGroupedOrder;
      orderRow.tempHash = item.tempHash;
      orderRow.quantity = item.quantity;
      orderRow.quantityUnit = item.quantityUnit || '';
      orderRow.bookingId = item.bookingId || '';
      orderRow.isSubscriptionOrderRow = item.isSubscriptionOrderRow;
      if (item.selectedArticle) {
        orderRow.selectedArticle = item.selectedArticle.glassesData
          ? item.selectedArticle.glassesData
          : item.selectedArticle.lensData;
      }
      if (orderRow.type === App.product.Type.FRAME) {
        orderRow.totalFrameItemPrice = item.totalItemPrice;
        orderRow.totalFrameItemPriceWithoutDiscount = item.totalItemPriceWithoutDiscount;
      }
      return orderRow;
    };

    const refreshAllProductsDiscounts = () => {
      const { cartItems } = window.dataLayer.quickCartOrderInfo;
      cartItems.forEach(({ productItem }) => {
        if (App.cartPage.orders[productItem.tempHash]) {
          App.cartPage.orders[productItem.tempHash].price = parseFloat(productItem.price);
        }
      });
    };

    const batchDeleteOrderRows = (props) => {
      const {
        order,
        orderUpdateResponse = null,
      } = props;

      if (order.isEmpty) {
        return;
      }

      TrackApp.trackCartPageEvent('cartRemove', order, orderUpdateResponse);
    };

    /**
         * Deletes order row from the cart
         * @param props:
         * @param props.rowHash - order row hash
         * @param props.orderUpdateResponse - response after /removerow ajax, contains actual cart data
         * @param props.replaceOrderRow - if should replace order row
         * @param props.batchDelete - when removing several cart items, should skip ajax with update cart, prices, etc.
         * @returns {Promise<void>}
         */
    const deleteOrderRow = async (props) => {
      const {
        rowHash,
        orderUpdateResponse = null,
        replaceOrderRow = false,
        batchDelete = false,
        oneProduct = true,
        cartDto = null,
      } = props;
      const order = App.cartPage.orders[rowHash];

      if (oneProduct && order && !replaceOrderRow) {
        $(order.element).slideUp(ANIMATION_DURATION, function removeOrderElement() {
          $(this).remove();
        });
      }
      delete App.cartPage.orders[rowHash];

      if (order.isEmpty) {
        return;
      }

      // Remove several order rows without updating quick cart, total price, etc. to minimize requests to the server.
      if (batchDelete) {
        batchDeleteOrderRows({ order, orderUpdateResponse });
        return;
      }

      await App.common.quickCart.update(cartDto);
      await App.eventBus.trigger('cart-page:update');
      TrackApp.trackCartPageEvent('cartRemove', order, orderUpdateResponse);
      App.eventBus.trigger('cartRemove');
      refreshAllProductsDiscounts();
    };

    const confirmRemovingProduct = (message, success) => {
      const callback = () => {
        if (typeof success === 'function') {
          success();
        }
      };

      App.ui.popup(message, {
        type: App.ui.popup.Type.DELETE_POPUP,
        confirm: {
          ok: {
            callback,
          },
        },
      });
    };

    const removeProduct = (rowHash, callback) => {
      App.cartPage.services.deleteFromCart(rowHash, async (orderUpdateResponse) => {
        await deleteOrderRow({ rowHash, orderUpdateResponse });
        if (typeof callback === 'function') {
          callback();
        }
      });
    };

    const removeProductFromCart = function removeProductFromCart(e, productRowHash, callback) {
      const rowHash = productRowHash || this.getAttribute('data-rowhash');
      const cartItem = App.cartPage.orders[rowHash] || {};

      if (cartItem.isEmpty) {
        deleteOrderRow({ rowHash });
      } else if (App.cartPage.subscriptions.isSubscriptionOrderRow(cartItem)) {
        // Subscription can be removed from the quick cart.
        App.cartPage.subscriptions.confirmRemovingFromCart({
          $deleteButton: $(this),
        });
      } else {
        const prodName = `<span class="product_wrapper">${cartItem.name || ''}</span>`;
        const message = texts('confirmRemove@cart').replace('\'@\'', prodName);
        confirmRemovingProduct(message, () => removeProduct(rowHash, callback));
      }
    };

    const setEventBusRemoveListeners = () => {
      App.eventBus.on('cart-page:remove-product', (e, rowHash) => removeProduct(rowHash));
      App.eventBus.on('cart-page:remove-products', async (e, props) => {
        const {
          removeProducts,
          response = null,
          asyncDelete = true,
          cartDto = null,
        } = props;
        let orderUpdateResponse = response;

        for (let i = 0; i < removeProducts.length; i += 1) {
          const rowHash = removeProducts[i];
          if (asyncDelete) {
            // eslint-disable-next-line no-await-in-loop
            orderUpdateResponse = await App.cartPage.services.asyncDeleteFromCart(rowHash);
          }
          const theLastProduct = i === removeProducts.length - 1;
          // eslint-disable-next-line no-await-in-loop
          await deleteOrderRow({
            rowHash,
            orderUpdateResponse,
            batchDelete: !theLastProduct,
            oneProduct: false,
            cartDto,
          });
        }

        App.eventBus.trigger('cart-page:products-removed', removeProducts);
      });
    };

    return {
      ANIMATION_DURATION,
      confirmRemovingProduct,
      deleteOrderRow,
      fillUpOrderRowConfig,
      isCart: () => isCartPage,
      orders,
      removeProduct,
      removeProductFromCart,
      refreshAllProductsDiscounts,
      setEventBusRemoveListeners,
      ...cartPageModule,
    };
  })();
})();
